import "assets/bootstrap.min.css";
import React from "react";
import { render } from "react-dom";
import App from "./App";
import "./index.css";

import { Provider } from 'react-redux'
import store from './rootReducer'

render(
<Provider store={store}>
    <App />
</Provider>,
document.getElementById("root")
);
